
// type Category = "demand" | "master" | "machines" | "product" | "inventory" | "commit" | "mapping";

// export type FileStatus = {
//   form_data_name: string;
//   status: boolean;
//   file: null | File;
//   category: Category;
//   columns?: GridColDef[];
//   table_data?: GridRowsProp;
// };

// export type MonthlyTitles = {
//   [key: string]: FileStatus;
// };

// export type MasterTitles = {
//   [key: string]: FileStatus;
// };

// export type PreCommit = {
//   monthlyTitles: MonthlyTitles;
//   masterTitles: MasterTitles;
// };

// export type FinalCommit = {
//   monthlyTitles: MonthlyTitles;
//   masterTitles: MasterTitles;
// };

// type Commit = {
//   pre_commit: PreCommit;
//   final_commit: FinalCommit;
// };

// export type Titles = {
//   monthlyTitles: MonthlyTitles;
//   masterTitles: MasterTitles;
// };

// export type ClientBasedFiles = {
//   [key: string]: Commit | Titles;
// };

export const clientBasedFiles
  // : ClientBasedFiles 
  = {
  sunpharma_dewas: {
    monthlyTitles: {},
    masterTitles: {},
  },
  sunpharma_baska: {
    monthlyTitles: {},
    masterTitles: {},
  },
  sunpharma_paonta_sahib: {
    monthlyTitles: {
    },
    masterTitles: {
      test_types_and_machine: {
        visible: true,
        display_name: "test_types_and_machine",
        form_data_name: "test_to_machine",
        status: false,
        file: null,
        category: "mapping",
      },
      test_types_and_analyst: {
        visible: true,
        display_name: "test_types_and_analyst",
        form_data_name: "test_to_analyst",
        status: false,
        file: null,
        category: "mapping",
      },
      recipe: {
        visible: true,
        display_name: "recipe",
        form_data_name: "recipe",
        status: false,
        file: null,
        category: "master",
      },
      analyst_availability: {
        visible: false,
        display_name: "analyst_availability",
        form_data_name: "analyst_availability",
        status: false,
        file: null,
        category: "constraint",
        optional: true,
      },
      test_configuration: {
        visible: true,
        display_name: "test_configuration / description",
        form_data_name: "test_description",
        status: false,
        file: null,
        category: "master",
      },
      machine_calibration_schedule: {
        visible: false,
        display_name: "machine_calibration_schedule",
        form_data_name: "machine_calibration_schedule",
        status: false,
        file: null,
        category: "master",
        optional: true
      },
      sla_data: {
        visible: true,
        display_name: "sla_data",
        form_data_name: "sla_data",
        status: false,
        file: null,
        category: "master",
      },
      // transactional_data: {
      //   visible: true,
      //   display_name: "transactional_data",
      //   form_data_name: "transaction",
      //   status: false,
      //   file: null,
      //   category: "demand",
      // },
    },
  },
};
